import MonetizationAPI from '../api/MonetizationAPI'

export default class MonetizationManager { 
	constructor(monetizations) { 
		this.monetizations = monetizations
		this.monetizationAPI = new MonetizationAPI()
	}

	findSurvey(type) { 
		if (this.monetizations === undefined || this.monetizations === null) { 
			return null
		}

		console.log("Monetizations not empty")
		console.log(this.monetizations)
		const requiredMonetization = this.monetizations.find(function(x) { 
			return x.kind === type
		})

		console.log(requiredMonetization)
		if (requiredMonetization !== undefined) { 
			return requiredMonetization
		} else { 
			return null
		}
	}

	getRequiredSurvey() { 
		return this.findSurvey("required_survey")
	}

	getOptionalSurvey() { 
		return this.findSurvey("optional_survey")
	}

	async sendCompletion(completion) { 
		if (completion == null) { 
			return null
		}

		const result = await this.monetizationAPI.sendMonetizationCompletion(completion)
		if (result === null || result.code === -1) { 
			return null
		}

		return result
	}
}